import { createStyles } from 'antd-style';

import {
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../../../theme';
import { mask } from '../../../styles/mixins';
import { drawerBase } from '../../../components/drawers/drawerBase';

export const useNewShipmentEmailNotificationsStyles = createStyles(
  ({ token }) => ({
    inlineLinkGrey: {
      color: `${token.colorText} !important`,
    },
    inlineLinkRed: {
      color: `${ThemeColors.COLOR_RED2} !important`,
    },
    addEmailNotifications: {
      color: ThemeColors.COLOR_RED2,
      fontWeight: 500,

      // Firefox renders in a buggy way if a parent has underline and a child contains text
      '> span:last-child': {
        textDecoration: 'underline',
      },
    },
    drawer: {
      ...drawerBase({ width: 320, token }),

      '&.ant-drawer.ant-drawer-open .ant-drawer-mask': {
        ...mask(65),
        backdropFilter: 'blur(2px)',
      },

      '.ant-drawer-content-wrapper': {
        top: ThemeSpaces.SPACE_SM,
        bottom: ThemeSpaces.SPACE_NORM_30,
        boxShadow: `-4px 4px 35px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY6, 0.65)}`,
      },

      '.ant-drawer-content': {
        border: `2px solid ${ThemeColors.COLOR_WHITE}`,
      },

      '.ant-drawer-header-title': {
        height: 36,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        borderBottomWidth: 0,

        '.ant-drawer-title': {
          fontFamily: ThemeFont.FONT_CONDENSED,
          fontWeight: 'bold',
          fontSize: token.fontSize,
          textTransform: 'uppercase',
        },
      },

      '.ant-drawer-body': {
        padding: `0 ${ThemeSpaces.SPACE_NORM}px ${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM}px`,
        flexDirection: 'column',
        alignItems: 'stretch',
      },

      'h4.ant-typography': {
        fontSize: 21,
        fontWeight: 300,
        letterSpacing: '-0.24px',
        color: '#6d7889',
        paddingTop: ThemeSpaces.SPACE_XS,
        paddingBottom: 5,
        borderBottom: `1px solid ${ThemeColors.COLOR_WHITE}`,
        marginBottom: ThemeSpaces.SPACE_NORM,
      },
    },
  })
);
